export const BREAKPOINTS = {
  xs: 449,
  sm: 768,
  md: 980,
  lg: 1200,
};
